import { render } from "./PdfDownloadButton.vue?vue&type=template&id=c9d4cb3c&scoped=true&ts=true"
import script from "./PdfDownloadButton.vue?vue&type=script&lang=ts"
export * from "./PdfDownloadButton.vue?vue&type=script&lang=ts"

import "./PdfDownloadButton.vue?vue&type=style&index=0&id=c9d4cb3c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d4cb3c"]])

export default __exports__